module.exports = __webpack_public_path__ + "media/images/application/icons/icon-arrow-right-421d11f45b728032873377f0fc22cb04.svg";